import { addGlobalListeners } from './listeners/globalListeners';
import { addArticleListeners } from './listeners/articleListeners';
import { addPageLoadEvents } from './listeners/pageLoadEvents';
import { addProductListeners } from './listeners/productListeners';
import { addPromoBoxListeners } from './listeners/promoBoxListeners';
import { addHeaderCTAListeners } from './listeners/headerCTAListener';
import { addHeroBannerListeners } from './listeners/heroBannerListeners';
import { addCampaignListeners } from './listeners/selectPromotionListeners';
import { addFormListeners } from './listeners/formListeners';
import { addFileDownloadListeners } from './listeners/fileDownloadListener';
import { addProductReviewsEvents } from './listeners/productReviewsEvents';
import { addGeoLocationsListeners } from './listeners/geoLocationsListeners';

export const addAnalyticsListeners = () => {
  addProductListeners();
  addArticleListeners();
  addPageLoadEvents();
  addGlobalListeners();
  addPromoBoxListeners();
  addHeaderCTAListeners();
  addHeroBannerListeners();
  addCampaignListeners();
  addFormListeners();
  addFileDownloadListeners();
  addProductReviewsEvents();
  addGeoLocationsListeners();
};
